<style scoped>
  a:hover {
    text-decoration: underline;
  }

  .add-free-text {
    font-size: 18px;
    color: var(--color-text-dark);
  }

  div {
    /*border: 1px solid pink;*/
  }
</style>

<template>
  <div style='font-size: 14px;'>
    <Confirm :show="deleteModal" :text="$text.tr('Удалить API ключ?')" :btname="$text.tr('УДАЛИТЬ')" @on-cancel="deleteModal = false"  @confirmed="del"/>
    <Confirm :show="deletionIsntAllowedModal" :text="$text.tr('Чтобы удалить ключ, остановите все бустеры')" btname="OK" @on-cancel="cancelDeletion"  @confirmed="cancelDeletion"/>
    <Modal v-model='fbotdata.showAddExchangeModal' @input="$emit('on-cancel', $event)" style="text-align: center;">
      <div style="margin-top: 50px">
        <div v-if="fbotdata.exchTokenId !== ''" style="padding-bottom: 20px; display: flex; justify-content: center; flex-wrap: wrap;">
          <div
            :class='{active: exch.Id === fbotdata.exchTokenId}'
            style="border: 1px solid #6b74e7; width: 100px; height: 50px; display: table;"
            :key='exch.Id'
            @click="selectExchange(fbotdata.exchanges[index].Id)"
            v-for='(exch, index) in fbotdata.exchanges'>
            <div style="display: table-cell; vertical-align: middle;">
              <div
                style='color: rgb(180,180,180); font-size: 14px; font-weight: bold; text-align: center;'>
                {{ exch.Name }}
              </div>
              <div>
                {{ exchValue(exch.Id) }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="fbotdata.exchTokenId !== ''" style="padding-bottom: 10px; font-size: 16px; color: var(--color-text-dark)">
          {{ $text.tr('ВВЕДИТЕ НОВЫЕ КЛЮЧИ') }}
        </div>
        <div v-else style="margin-bottom: 15px; font-size: 16px;">
          <div style="color: var(--color-text-dark)">{{ $text.tr('ДОБАВЬТЕ API КЛЮЧ') }}</div>
<!--          <a href="https://capico.app/info/registration-futures/" target="_blank" style="color: var(--color-text-dark);">-->
<!--            ИНСТРУКЦИЯ-->
<!--          </a>-->
          <div style="height: 70px; margin-top: 15px">
            <i-switch v-model="binanceFree" style="margin-right: 8px; margin-bottom: 3px;" size="small"/>
            <span>{{ $text.tr('Использовать бесплатно.') }} <a :href="$text.tr('https://doc.capico.app/v/ru/ex/use/binance')" target="_blank" style="color: #6b74e7">{{ $text.tr('Узнать как') }}</a></span><br>
              <span v-if="binanceFree" class="yell">{{ $text.tr('Внимание! Если ваш аккаунт не является реферальным,') }}<br>{{ $text.tr(' он будет отключен от платформы') }}</span>
          </div>
        </div>
      <i-input v-if="fbotdata.exchTokenId === ''" v-model='name' style='margin-top: 20px;' size='large' :maxlength="80">
        <span slot='prepend'><div style='font-size: 14px; width: 100px;'>{{ $text.tr('Название') }}</div></span>
      </i-input>
      <i-input v-model='apikey' style='margin-top: 20px;' size='large'>
        <span slot='prepend'><div style='font-size: 14px; width: 100px;'>API Key</div></span>
      </i-input>
      <i-input v-model='apisecret' style='margin: 20px 0px;' size='large'>
        <span slot='prepend'><div style='font-size: 14px; width: 100px;'>API Secret</div></span>
      </i-input>
      </div>
      <div slot="footer" style="text-align: center;">
        <Button v-if="fbotdata.exchTokenId === ''" :loading="loading" :disabled="loading" size="default" long style="width: 80%; margin-top: 20px; margin-bottom: 10px" @click="save">
          <div v-if="!loading">{{ $text.tr('ДОБАВИТЬ') }}</div>
        </Button>
        <div v-else>
          <Button :disabled="loading" size="default" style="width: 30%; margin-top: 20px; margin-bottom: 10px; background-color: #a53748" @click="showDeleteModal">
            <div>{{ $text.tr('УДАЛИТЬ') }}</div>
          </Button>
          <Button  :loading="loading" :disabled="loading" size="default" long style="width: 60%; margin-top: 20px; margin-bottom: 10px" @click="update">
            <div v-if="!loading">{{ $text.tr('ОБНОВИТЬ') }}</div>
          </Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
// @ts-ignore
import Api from '@/util/api'
import fastbot from '@/services/fastbot'
import { Exchange, FastbotData } from '@/util/types'
// @ts-ignore
import Confirm from '@/components/common/Confirm'
// @ts-ignore
import SlimApi from '@/util/slimapi'
import Util from '@/util/util'

  @Component({
    components: {
      Confirm
    }
  })
export default class FastbotAddExchangeModal extends Vue {
  name = 'Futures'
  apikey = ''
  apisecret = ''
  loading = false
  deleteModal = false
  deletionIsntAllowedModal = false
  binanceFree = false

  get fbotdata () {
    // @ts-ignore
    return (this.$store.state.fastbot as FastbotData)
  }

  exchValue (id: string) {
    // @ts-ignore
    if (this.$store.state.sys.exchValue[id]) {
      // @ts-ignore
      switch (this.$store.state.sys.usdbtc) {
        case 'USD':
          // @ts-ignore
          return '$' + this.$store.state.sys.exchValue[id].usd
        case 'BTC':
          // @ts-ignore
          return this.$store.state.sys.exchValue[id].btc + ' BTC'
      }
    }
    return ''
  }

  selectExchange (id: string) {
    this.fbotdata.selected = undefined
    this.fbotdata.list = []
    this.fbotdata.excOrders = []
    this.fbotdata.exchTokenId = id
    localStorage.setItem('capico_app_booster_exchange', id)
    this.cleanFields()
    this.fbotdata.showAddExchangeModal = false
  }

  save () {
    // console.log('save')
    if (this.loading) {
      return
    }
    this.loading = true
    if (this.name === '' || this.apikey === '' || this.apisecret === '') {
      // @ts-ignore
      this.$Message.error(this.$text.tr('Ошибка: заполните все поля'))
      this.updateLoading()
      return
    }
    // if (this.email.length > 0) {
    //   if (!this.validateEmail(this.email)) {
    //     // @ts-ignore
    //     this.$Message.error('Ошибка: введите правильный email')
    //     this.updateLoading()
    //     return
    //   }
    // }
    // @ts-ignore

    const params = {
      eid: 'BIF',
      name: this.name,
      apikey: this.apikey,
      secret: this.apisecret,
      email: ''
    }

    if (this.binanceFree) {
      params.email = 'futuresfree'
    }

    const ref = this
    SlimApi.post(`user/add_exch?token=${ref.$store.state.sys.token}&email=${params.email}`, params)
      .then(async function (response: any) {
        // console.log(response.data)
        // console.log(response.data.err)
        ref.updateLoading()
        if (response.data.err) {
          if (response.data.err === 'apikey and secret aren\'t valid') {
            // @ts-ignore
            ref.$Notice.error({
              // @ts-ignore
              title: ref.$text.tr('Ошибка'),
              // @ts-ignore
              desc: ref.$text.tr('неверный API key или API secret'),
              duration: 10
            })
          } else {
            // @ts-ignore
            ref.$Notice.error({
              // @ts-ignore
              title: ref.$text.tr('Ошибка'),
              desc: Util.returnTextForErr(response.data.err),
              duration: 10
            })
          }
        } else {
          ref.fbotdata.showAddExchangeModal = false
          await fastbot.updateFastbotExchangeAsync()
          // @ts-ignore
          await ref.$store.dispatch('updateExchangesAsync')
          ref.cleanFields()
          // @ts-ignore
          ref.$Notice.success({
            // @ts-ignore
            title: ref.$text.tr('Биржа добавлена'),
            duration: 6
          })
        }
      })
      .catch(function (error: string) {
        console.log(error)
        // @ts-ignore
        ref.$Notice.error({
          // @ts-ignore
          title: ref.$text.tr('Ошибка'),
          desc: Util.returnTextForErr(error),
          duration: 10
        })
        ref.updateLoading()
      })
  }

  // validateEmail (email: string) {
  //   // eslint-disable-next-line
  //   var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  //   return re.test(String(email).toLowerCase())
  // }

  updateLoading () {
    this.loading = false
  }

  update () {
    if (this.loading) {
      return
    }
    if (this.apikey === '' || this.apisecret === '') {
      // @ts-ignore
      this.$Notice.error({
        // @ts-ignore
        title: this.$text.tr('Ошибка'),
        // @ts-ignore
        desc: this.$text.tr('заполните все поля'),
        duration: 10
      })
      this.updateLoading()
      return
    }
    this.loading = true
    let name: string = 'Futures'
    this.fbotdata.exchanges.forEach((exch: Exchange) => {
      if (exch.Id === this.fbotdata.exchTokenId) {
        name = exch.Name
      }
    })
    const params = {
      // @ts-ignore
      token: this.$store.state.sys.token,
      etid: this.fbotdata.exchTokenId,
      name,
      apikey: this.apikey,
      secret: this.apisecret
    }
    const ref = this
    Api.get('user/upd_exch', {
      params
    }).then((response: any) => {
      this.updateLoading()
      if (response.data.err) {
        if (response.data.err === 'apikey and secret aren\'t valid') {
          // @ts-ignore
          ref.$Notice.error({
            // @ts-ignore
            title: ref.$text.tr('Ошибка'),
            // @ts-ignore
            desc: ref.$text.tr('неверный API key или API secret'),
            duration: 10
          })
        } else {
          // @ts-ignore
          ref.$Notice.error({
            // @ts-ignore
            title: ref.$text.tr('Ошибка'),
            // @ts-ignore
            desc: Util.returnTextForErr(response.data.err),
            duration: 10
          })
        }
      } else {
        ref.cleanFields()
        fastbot.updateFastbotExchangeAsync()
        // @ts-ignore
        this.$store.dispatch('updateExchangesAsync')
        // @ts-ignore
        ref.fbotdata.showAddExchangeModal = false
        // @ts-ignore
        ref.$Notice.success({
          // @ts-ignore
          title: ref.$text.tr('API ключи обновлены'),
          duration: 6
        })
      }
    }).catch(function (error: string) {
      console.log(error)
      // @ts-ignore
      ref.$Notice.error({
        // @ts-ignore
        title: ref.$text.tr('Ошибка'),
        desc: Util.returnTextForErr(error),
        duration: 10
      })
      ref.updateLoading()
    })
  }

  showDeleteModal () {
    // check active boosters
    if (this.fbotdata.type === 'ACT' && this.fbotdata.list.length > 0) {
      this.deletionIsntAllowedModal = true
    } else if (this.fbotdata.type === 'HIST') {
      this.getActiveList()
    } else {
      this.deleteModal = true
    }
  }

  cancelDeletion () {
    this.deletionIsntAllowedModal = false
    this.fbotdata.showAddExchangeModal = false
  }

  getActiveList () {
    const params = {
      params: {
        // @ts-ignore
        token: this.$store.state.sys.token,
        // @ts-ignore
        etid: this.fbotdata.exchTokenId,
        status: 'ACT',
        page: 0
      }
    }
    const ref = this
    SlimApi.get('fastbot/list', params)
      .then((response: any) => {
        // console.log('getActiveList:', response.data)
        if (response.data !== null) {
          if (!response.data.err) {
            if (response.data.length > 0) {
              ref.deletionIsntAllowedModal = true
            }
          } else {
            // console.log(response.data.err)
            // @ts-ignore
            ref.$Notice.error({
              // @ts-ignore
              title: ref.$text.tr('Ошибка'),
              desc: Util.returnTextForErr(response.data.err),
              duration: 10
            })
          }
        } else {
          ref.deleteModal = true
        }
      }).catch((error: any) => {
        console.log(error)
        // @ts-ignore
        ref.$Notice.error({
          // @ts-ignore
          title: ref.$text.tr('Ошибка'),
          desc: Util.returnTextForErr(error),
          duration: 10
        })
      })
  }

  del () {
    if (this.loading) {
      return
    }
    this.deleteModal = false
    this.loading = true
    const ref = this
    Api.get('user/del_exch', {
      params: {
        // @ts-ignore
        token: this.$store.state.sys.token,
        etid: this.fbotdata.exchTokenId
      }
    }).then((response: any) => {
      ref.updateLoading()
      if (response.data !== null) {
        if (!response.data.err) {
          ref.cleanFields()
          if (ref.fbotdata.exchanges.length === 1) {
            ref.fbotdata.exchanges = []
            ref.fbotdata.exchTokenId = ''
            ref.fbotdata.freeBal = '0'
            ref.fbotdata.selected = undefined
            ref.fbotdata.excOrders = []
          } else {
            fastbot.updateFastbotExchangeAsync()
          }
          // @ts-ignore
          this.$store.dispatch('updateExchangesAsync')
          ref.fbotdata.showAddExchangeModal = false
        } else {
          console.log(response.data.err)
          // @ts-ignore
          ref.$Notice.error({
            // @ts-ignore
            title: ref.$text.tr('Ошибка'),
            desc: Util.returnTextForErr(response.data.err),
            duration: 10
          })
        }
      }
    }).catch(function (error: string) {
      console.log(error)
      ref.updateLoading()
      // @ts-ignore
      ref.$Notice.error({
        // @ts-ignore
        title: ref.$text.tr('Ошибка'),
        desc: Util.returnTextForErr(error),
        duration: 10
      })
    })
  }

  cleanFields () {
    this.apisecret = ''
    this.apikey = ''
    this.name = 'Futures'
  }
}
</script>
